import { useState } from 'react';
import { Save, Check, User } from 'lucide-react';
import { getSettings, saveSettings } from '../lib/settings';
import { useAuthStore } from '../store/authStore';

export default function SettingsView() {
  const [form, setForm] = useState(getSettings());
  const [saved, setSaved] = useState(false);
  const { user, logout } = useAuthStore();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    saveSettings(form);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="max-w-xl mx-auto">
      <div className="sl-card p-6">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 rounded-xl bg-cobalt-soft flex items-center justify-center">
            <User className="w-5 h-5 text-cobalt" />
          </div>
          <h2 className="sl-h2">Einstellungen</h2>
        </div>
        <p className="text-ink-mute mb-6 text-sm">
          Diese Angaben werden bei neuen Arbeitsblättern automatisch vorausgefüllt.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-ink-soft mb-1.5">Lehrkraft</label>
            <input value={form.teacher} onChange={(e) => setForm({ ...form, teacher: e.target.value })}
              className="sl-input" placeholder="z.B. Frau Müller" />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink-soft mb-1.5">Schule</label>
            <input value={form.school} onChange={(e) => setForm({ ...form, school: e.target.value })}
              className="sl-input" placeholder="z.B. Grundschule am Park" />
          </div>
          <div>
            <label className="block text-sm font-medium text-ink-soft mb-1.5">Schuljahr</label>
            <input value={form.schoolYear} onChange={(e) => setForm({ ...form, schoolYear: e.target.value })}
              className="sl-input" placeholder="2025 / 26" />
          </div>

          <div className="flex items-center gap-3 pt-1">
            <button type="submit" className="sl-button sl-button-primary gap-2">
              <Save className="w-4 h-4" />Speichern
            </button>
            {saved && <span className="inline-flex items-center gap-1 text-sage text-sm font-medium"><Check className="w-4 h-4" />Gespeichert</span>}
          </div>
        </form>
      </div>

      {user && (
        <div className="sl-card p-6 mt-4">
          <div className="text-xs font-bold text-ink-soft uppercase tracking-wide mb-3">Konto</div>
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="font-semibold text-ink truncate">{user.name}</p>
              {user.email && <p className="text-sm text-ink-mute truncate">{user.email}</p>}
            </div>
            <button onClick={logout} className="sl-button sl-button-outline text-coral border-coral/30 hover:bg-coral-soft">
              Abmelden
            </button>
          </div>
        </div>
      )}

      <p className="text-xs text-ink-mute mt-3">
        Hinweis: Diese Voreinstellungen werden lokal in diesem Browser gespeichert.
      </p>
    </div>
  );
}
